import React, { useEffect, useState } from 'react'
import toast, { Toaster } from 'react-hot-toast';
import config from "../coreFIles/config";
import Header from '../directives/header'
import Leftnav from '../directives/leftSidebar'
import Rightnav from '../directives/rightSidebar'
import Footer from '../directives/footer'
import Cookies from 'js-cookie'
import Swal from "sweetalert2";
import { getMemberAdsAction, deleteadAction, adBlockUnBlockAction, repostAdsAction, bulkdeleteadAction, getPlansAction, createAdUpgradePaymentIntentAction, upgradeAdWithPaymentAction } from '../Action/action';
import { getDomainStyles } from '../utils/staticDomainData';
import { getDomainIdWithData } from '../utils/domainHelpers';

const Domainid = getDomainIdWithData();
const ManageAd = () => {
	// Style state for reactive styling - use static domain data
	const [Style, setStyle] = useState([]);
	
	useEffect(() => {
		const updateStyles = () => {
			try {
				const domainId = Domainid?.domain_id || 0;
				const domainStyles = getDomainStyles(domainId);
				setStyle(domainStyles || []);
			} catch (error) {
				console.error('Error getting domain styles in ManageAd:', error);
				setStyle([]);
			}
		};
		
		updateStyles();
		const interval = setInterval(updateStyles, 500);
		return () => clearInterval(interval);
	}, []);
	
	// Style values
	const getStyleValue = (key) => {
		if (Style && Array.isArray(Style) && Style.length > 0 && Style[0] && Style[0][key]) {
			return `#${Style[0][key]}`;
		}
		return '';
	};
	const timeColor = getStyleValue('time_color');
	const headerButtonColor = getStyleValue('header_buttoncolor');
	const headerMenuColor = getStyleValue('header_menu');
	const headerMenuHoverColor = getStyleValue('header_menu_hover');
	const header_search_text = getStyleValue('header_search_text');
	
  if (!Cookies.get('loginSuccessMember')) {
    window.location.href = `${config.baseUrl}`;
  }

  const getLoginData = () => {
	try {
		const cookieData = Cookies.get('loginSuccessMember');
		return cookieData ? JSON.parse(cookieData) : [];
	} catch (error) {
		console.error('Error parsing loginSuccessMember cookie:', error);
		return [];
	}
  };
  const loginData = getLoginData();
  const memberId = loginData?.id;
  const [spinloader, setspinloader] = useState(0);
  const [adsList, setAdsList] = useState({});
  const [selectedads, setSelectedads] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [selectedAd, setSelectedAd] = useState(null);
  const [plansList, setPlansList] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [stripe, setStripe] = useState(null);
  const [cardElement, setCardElement] = useState(null);
  const [paymentProcessing, setPaymentProcessing] = useState(false);

  useEffect(() => {
    setspinloader(1)
    getMemberAds();
    getPlans();
    loadStripe();
  }, [])

  // Load Stripe.js
  const loadStripe = () => {
    if (window.Stripe) {
      setStripe(window.Stripe(config.stripePublishableKey));
    } else {
      const script = document.createElement('script');
      script.src = 'https://js.stripe.com/v3/';
      script.async = true;
      script.onload = () => {
        setStripe(window.Stripe(config.stripePublishableKey));
      };
      document.body.appendChild(script);
    }
  }

  // Initialize Stripe Elements when modal opens and plan is selected
  useEffect(() => {
    if (stripe && showUpgradeModal && selectedPlan) {
      const elements = stripe.elements();
      const card = elements.create('card', {
        style: {
          base: {
            fontSize: '16px',
            color: '#424770',
            '::placeholder': {
              color: '#aab7c4',
            },
          },
          invalid: {
            color: '#9e2146',
          },
        },
      });
      
      const cardElementDiv = document.getElementById('upgrade-ad-card-element');
      if (cardElementDiv) {
        card.mount('#upgrade-ad-card-element');
        setCardElement(card);

        card.on('change', ({error}) => {
          const displayError = document.getElementById('upgrade-ad-card-errors');
          if (error) {
            displayError.textContent = error.message;
          } else {
            displayError.textContent = '';
          }
        });
      }

      return () => {
        if (card) {
          card.unmount();
        }
      };
    }
  }, [stripe, showUpgradeModal, selectedPlan])

  const getPlans = async () => {
    try {
      let res = await getPlansAction();
      if (res.success) {
        setPlansList(res.data || []);
      }
    } catch (error) {
      console.error('Error fetching plans:', error);
    }
  }

  const handleUpgradeClick = (ad) => {
    setSelectedAd(ad);
    setSelectedPlan(null);
    setShowUpgradeModal(true);
  }

  const handlePlanSelect = (plan) => {
    setSelectedPlan(plan);
  }

  const processAdUpgradePayment = async () => {
    try {
      if (!selectedAd || !selectedPlan) {
        toast.error("Please select a plan");
        return;
      }

      if (!stripe || !cardElement) {
        toast.error("Payment system not ready. Please refresh the page.");
        return;
      }

      setPaymentProcessing(true);

      // Step 1: Create payment intent
      const paymentIntentRes = await createAdUpgradePaymentIntentAction({ 
        plan_id: selectedPlan.plan_id,
        ad_id: selectedAd.id,
        member_id: loginData?.id,
        email: loginData?.email 
      });
      
      if (!paymentIntentRes.success) {
        toast.error(paymentIntentRes.msg || "Failed to initialize payment");
        setPaymentProcessing(false);
        return;
      }

      // Step 2: Confirm payment with Stripe
      const { error: stripeError, paymentIntent: confirmedPaymentIntent } = await stripe.confirmCardPayment(
        paymentIntentRes.client_secret,
        {
          payment_method: {
            card: cardElement,
            billing_details: {
              name: `${loginData?.fname || ''} ${loginData?.lname || ''}`.trim() || loginData?.email,
              email: loginData?.email,
            },
          },
        }
      );

      if (stripeError) {
        toast.error(stripeError.message || "Payment failed");
        setPaymentProcessing(false);
        return;
      }

      if (confirmedPaymentIntent.status === 'succeeded') {
        // Step 3: Upgrade ad with payment intent ID
        const fromDate = new Date().toISOString().slice(0, 10);
        const toDate = new Date();
        toDate.setDate(toDate.getDate() + selectedPlan.days);
        const toDateStr = toDate.toISOString().slice(0, 10);

        const upgradeRes = await upgradeAdWithPaymentAction({
          adid: selectedAd.id,
          plan_id: selectedPlan.plan_id,
          planDays: selectedPlan.days,
          planAmount: selectedPlan.price,
          from_date: fromDate,
          payment_intent_id: confirmedPaymentIntent.id
        });
        
        if (upgradeRes.success) {
          toast.success(upgradeRes.msg);
          setShowUpgradeModal(false);
          setSelectedAd(null);
          setSelectedPlan(null);
          getMemberAds();
        } else {
          toast.error(upgradeRes.msg || "Upgrade failed");
          setPaymentProcessing(false);
        }
      } else {
        toast.error("Payment not completed");
        setPaymentProcessing(false);
      }
    } catch (error) {
      console.error('Payment Error:', error);
      toast.error("An error occurred during payment. Please try again.");
      setPaymentProcessing(false);
    }
  }

  const getMemberAds = async () => {
    try {
      let res = await getMemberAdsAction({ id: memberId,domain_id:Domainid.domain_id });
      setAdsList(res.data);
      
      setspinloader(0)
    }
    catch (error) {
      console.error(error);
    }

  };

  const deleteradd = async (adid) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Delete this Ad!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Deleted it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let res = await deleteadAction({ id: adid });
        if (res.success) {
          getMemberAds();
          Swal.fire("Deleted!", res.msg, "success");
        } else {
          Swal.fire("Failed!", res.msg, "error");
        }
      }
    });
  };

  const adBlockUnBlock = async (adid, is_active) => {
    Swal.fire({
      title: 'Are you sure?',
      text: is_active == 0 ? "You want to deactivate this ad!”" : "You want to activate this ad!”",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: is_active == 0 ? 'Yes, Deactivate it!' : 'Yes, Activate it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        let res = await adBlockUnBlockAction({ 'id': adid, 'status': is_active });
        if (res.success) {
          getMemberAds();
          Swal.fire(
            is_active == 0 ? 'Deactivated!' : 'Activated',
            res.msg,
            'success'
          )
        } else {
          Swal.fire(
            'Failed!',
            res.msg,
            'error'
          )
        }
      }
    })
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedads([]);
    } else {
      setSelectedads(adsList.map(record => record.id));
    }
    setSelectAll(!selectAll);
  };

  const handleCheckboxChange = (id) => {
    if (selectedads.includes(id)) {
      setSelectedads(selectedads.filter(recordId => recordId !== id));
    } else {
      setSelectedads([...selectedads, id]);
    }
  };

  const rePostSelectedAds = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Repost Selected Ads!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Repost these!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let res = await repostAdsAction(selectedads);
        if (res.success) {
          setSelectedads([]);
          Swal.fire("Reposted!", res.msg, "success");
        } else {
          Swal.fire("Failed!", res.msg, "error");
        }
      }
    });
  };

  const deleteSelectedAds = async (adid) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Delete Selected Ads!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Deleted these!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let res = await bulkdeleteadAction(selectedads);
        if (res.success) {
          getMemberAds();
          setSelectedads([]);
          Swal.fire("Deleted!", res.msg, "success");
        } else {
          Swal.fire("Failed!", res.msg, "error");
        }
      }
    });
  };



  return (
    <>
      <Header />
      <div className="add-section mb-3">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <Leftnav />
            </div>
            <div className="col-lg-6">
              <Toaster />
              <div className="classification-section">
                <h2 className="page-heading" style={{background:headerMenuColor}}> Manage Ads </h2>

                <div className="mt-3">
                  <div className="table-responsive table-striped ">
                    <table className="table">
                      <thead>
                        <tr className='lightbluebg' style={{background:headerMenuColor}}>
                          <th>
                            {adsList != null && adsList.length > 0 ?
                              <input type='checkbox' name='checkAllad' id='checkAllad' checked={selectAll}
                                onChange={handleSelectAll} />
                              : ''}
                          </th>
                          <th>Ad Title</th>
                          <th>Type</th>
                          <th>Days Left</th>
                          <th>Upgrade</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          spinloader === 0 ?
                            adsList != null && adsList.length > 0 ?
                              adsList.map((row, index) => (
                                <tr key={index}>
                                  <td><input type='checkbox' name='checkad' id={'checkad' + row.id} checked={selectedads.includes(row.id)} onChange={() => handleCheckboxChange(row.id)} /> </td>
                                  <td>{row.title}</td>
                                  <td>{row.plan_type == 1 ? 'Featured' : row.plan_type == 2 ? 'Premium' : 'Free'}</td>
                                  <td>{row.plan_id != 0 ? row.daysLeft + ' Days Left' : 'Free'}</td>
                                  <td> 
                                    {row.plan_type == 2 ? (
                                      <span>-</span>
                                    ) : (
                                      <button 
                                        className="btn btn-sm btn-primary upgrade-btn-blue" 
                                        id="editbtnid"
                                        onClick={() => handleUpgradeClick(row)}
                                      >
                                        Upgrade
                                      </button>
                                    )}
                                  </td>
                                  <td>{row.status == 1 ?
                                    <>
                                      <button type="button" className="btn btn-primary btn-sm action-btn-sm" id="editbtnid" onClick={() => adBlockUnBlock(row.id, 0)}><i className='fa fa-ban'></i> Active</button>
                                    </>
                                    :
                                    <>
                                      <button type="button" className="btn btn-danger btn-sm action-btn-sm" id="editbtnid" onClick={() => adBlockUnBlock(row.id, 1)}><i className='fa fa-unlock'></i> Inactive</button>
                                    </>
                                  }

                                  </td>
                                  <td> <a href={`${config.baseUrl}edit-ad/${row.id}`} className="btn btn-sm btn-primary action-btn-sm" id="editbtnid"><span><i class="fa-solid fa-pen-to-square"></i></span></a>
                                    &nbsp;
                                    <button
                                      type="button"
                                      className="btn btn-primary action-btn-sm"
                                      id="editbtnid"
                                      onClick={() => deleteradd(row.id)}
                                    >
                                      <span><i class="fa-solid fa-trash"></i></span>
                                    </button>
                                    &nbsp;</td>
                                </tr>
                              ))
                              :
                              <tr>
                                <td colSpan="7">No ad found to display.</td>
                              </tr>
                            : (
                              <tr>
                                <td colSpan="7">
                                  <div className="buy-end-sell">
                                    <div className="loaderDiv">
                                      <img className="loaderImg" src={config.baseUrl + "img/loader.gif"} height={50} width={50} />
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            )}

                        {selectedads.length > 1 && (
                          <tr>
                            <td colSpan="7" className="text-right">
                              <button className="btn btn-sm btn-primary" onClick={() => rePostSelectedAds()}>Repost</button>&nbsp;&nbsp;
                              <button className="btn btn-sm btn-primary" onClick={() => deleteSelectedAds()}>Delete Selected</button>
                            </td>
                          </tr>
                        )}

                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <Rightnav />
            </div>
          </div>
        </div>
      </div>
      <Footer />

      {/* Upgrade Ad Modal */}
      {showUpgradeModal && (
        <div className="modal fade show upgrade-modal-backdrop">
          <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-fullscreen-sm-down modal-lg upgrade-modal-dialog">
            <div className="modal-content upgrade-modal-content" id="model_backgrond">
              <div className="modal-header upgrade-modal-header">
                <button 
                  type="button" 
                  className="upgrade-modal-close" 
                  onClick={() => {
                    setShowUpgradeModal(false);
                    setSelectedAd(null);
                    setSelectedPlan(null);
                  }}
                  aria-label="Close"
                >
                  <i className="fa fa-times"></i>
                </button>
              </div>

              <div className="modal-body text-center upgrade-modal-body">
                <div className="mb-3">
                  <h4 className="upgrade-modal-title">Upgrade Ad to Premium</h4>
                  {selectedAd && (
                    <p className="upgrade-modal-text">
                      <strong>Ad Title:</strong> {selectedAd.title}
                    </p>
                  )}
                  <p className="upgrade-modal-description">
                    Select a premium plan to upgrade your ad and get more visibility
                  </p>
                </div>
                
                <div id="model_img" className="container-fluid upgrade-plan-container">
                  <div className="row g-2 justify-content-center">
                    {plansList.length > 0 ? (
                      plansList.map((plan, index) => {
                        const isSelected = selectedPlan?.plan_id === plan.plan_id;
                        const gradientColors = [
                          'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                          'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                          'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                          'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
                          'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
                          'linear-gradient(135deg, #30cfd0 0%, #330867 100%)'
                        ];
                        const gradient = gradientColors[index % gradientColors.length];
                        
                        return (
                          <div key={index} className="col-6 col-md-4 d-block text-center upgrade-plan-col" role="button">
                            <div 
                              className={`card upgrade-plan-card ${isSelected ? 'selected' : ''}`}
                              style={{ 
                                background: isSelected ? gradient : undefined
                              }}
                              data-gradient={gradient}
                              onMouseEnter={(e) => {
                                if (!isSelected) {
                                  e.currentTarget.style.background = gradient;
                                }
                              }}
                              onMouseLeave={(e) => {
                                if (!isSelected) {
                                  e.currentTarget.style.background = '';
                                }
                              }}
                              onClick={() => handlePlanSelect(plan)}
                            >
                              {isSelected && (
                                <div className="upgrade-plan-selected-badge">
                                  <i className="fa fa-check"></i>
                                </div>
                              )}
                              
                              <div className="card-body text-center upgrade-plan-card-body">
                                <div className={`upgrade-plan-days ${isSelected ? 'selected' : ''}`}>
                                  <i className="fa fa-calendar"></i>
                                  {plan.days} Days
                                </div>
                                
                                <div className="upgrade-plan-price-container">
                                  <span className={`upgrade-plan-price-symbol ${isSelected ? 'selected' : ''}`}>$</span>
                                  <h3 className={`upgrade-plan-price ${isSelected ? 'selected' : ''}`}>
                                    {plan.price}
                                  </h3>
                                </div>
                                
                                {isSelected && (
                                  <div className="upgrade-plan-selected-label">
                                    <span>✓ Selected</span>
                                  </div>
                                )}
                              </div>
                              
                              {isSelected && (
                                <div className="upgrade-plan-selected-indicator"></div>
                              )}
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="col-12">
                        <p className="text-center upgrade-no-plans">No plans available</p>
                      </div>
                    )}
                  </div>
                </div>

                {selectedPlan && (
                  <div className="mt-2 upgrade-payment-section">
                    <div className="mb-4">
                      <h5 className="upgrade-payment-heading">Payment Details</h5>
                      <div className="alert alert-info mb-3 upgrade-payment-alert">
                        <strong>Selected Plan:</strong>
                        <span>{selectedPlan.days} Days - ${selectedPlan.price}</span>
                      </div>
                    </div>
                    
                    <div className="form-group text-left">
                      <label htmlFor="upgrade-ad-card-element" className="upgrade-card-label">
                        Card Details <span className='text-danger'>*</span>
                      </label>
                      <div id="upgrade-ad-card-element" className="upgrade-card-element-container">
                        {/* Stripe Card Element will be mounted here */}
                      </div>
                      <div id="upgrade-ad-card-errors" role="alert" className="upgrade-card-errors"></div>
                      <p className="mt-2 upgrade-card-info">
                        <i className="fa fa-lock"></i>
                        Amount: <strong>${selectedPlan.price}</strong> will be charged securely.
                      </p>
                    </div>

                    <div className="text-center upgrade-button-container">
                      <button 
                        type="button" 
                        className="btn btn-secondary upgrade-cancel-btn" 
                        onClick={() => {
                          setShowUpgradeModal(false);
                          setSelectedAd(null);
                          setSelectedPlan(null);
                        }}
                        disabled={paymentProcessing}
                      >
                        Cancel
                      </button>
                      <button 
                        type="button" 
                        className="btn btn-primary upgrade-pay-btn" 
                        onClick={processAdUpgradePayment}
                        disabled={paymentProcessing}
                        style={{ background: headerButtonColor }}
                      >
                        {paymentProcessing ? (
                          <>
                            <i className="fa fa-spinner fa-spin"></i>
                            Processing...
                          </>
                        ) : (
                          <>
                            Pay ${selectedPlan.price} & Upgrade
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default ManageAd;

